import React from "react";
import Image from "next/image";
import styles from "../TokensTable.module.scss";

export interface MobileSortDropdownProps {
  open: boolean;
  sort: { key: string; dir: string };
  mobileColumns: { key: string; label: string }[];
  onSelect: (colKey: string) => void;
  onToggle: () => void;
}

export const MobileSortDropdown: React.FC<MobileSortDropdownProps> = ({
  open,
  sort,
  mobileColumns,
  onSelect,
  onToggle,
}) => {
  return (
    <div className={styles.mobileSortRow}>
      <div className={styles.mobileSortWrap}>
        <div className={styles.mobileSortBox} onClick={onToggle}>
          <span className={styles.mobileSortText}>
            {mobileColumns.find((c) => c.key === sort.key)?.label || "Market cap"}
          </span>
          <Image
            src={"/tkn_lnd_pg_assets/images/icons/icon-sort-updown.svg"}
            alt="sort dropdown"
            className={styles.mobileSortIcon}
            width={16}
            height={16}
          />
        </div>
        {open && (
          <div className={styles.mobileSortDropdown}>
            {mobileColumns.map((col) => (
              <div
                key={col.key}
                className={styles.mobileSortDropdownItem}
                onClick={() => onSelect(col.key)}
              >
                <span className={styles.nameSymbol}>
                  {col.label} {sort.key === col.key && (
                    <Image
                      src={
                        sort.dir === "desc"
                          ? "/tkn_lnd_pg_assets/images/icons/icon-sort-down.svg"
                          : "/tkn_lnd_pg_assets/images/icons/icon-sort-up.svg"
                      }
                      alt="sort direction"
                      className={styles.mobileSortDropdownSortIcon}
                      width={16}
                      height={16}
                    />
                  )}
                </span>
                {sort.key === col.key && (
                  <Image
                    src={"/tkn_lnd_pg_assets/images/icons/icon-checkmark.svg"}
                    alt="active sort"
                    className={styles.mobileSortDropdownCheckIcon}
                    width={16}
                    height={16}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
